module.exports = __webpack_public_path__ + "fa-solid-900.svg?a297e4ae7710edcf5724b5dbed5b3f95";


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fortawesome/fontawesome-free-webfonts/webfonts/fa-solid-900.svg
// module id = 653
// module chunks = 3